const basePath = "/assets/img/HomePage/Clients/logos/";
export const clients = [
  {
    id: "1",
    src: basePath + "building-market.png",
  },
  {
    id: "2",
    src: basePath + "direct-aid.png",
  },
  {
    id: "3",
    src: basePath + "tawakul-karman.png",
  }
  ,
  {
    id: "4",
    src: basePath + "namaa.png",
  }
  ,
  {
    id: "5",
    src: basePath + "sna.avif",
  }
  ,
  {
    id: "6",
    src: basePath + "noonmar.png",
  }
  ,
  {
    id: "7",
    src: basePath + "human-appeal.png",
  }
  ,
  {
    id: "8",
    src: basePath + "fieldready.avif",
  }
  ,
  {
    id: "9",
    src: basePath + "moi.png",
  },
   {
    id: "10",
    src: basePath + "midmar.png",
  }
  ,
   {
    id: "11",
    src: basePath + "malteser.png",
  }
   ,
   {
    id: "12",
    src: basePath + "orphan.png",
  }
 
];
